/// <amd-module name="Dashboards/DashboardPanel/CreateDashboardPanel" />
import { Dashboard } from "Dashboards/Common/Contracts/Dashboard";
import { TeamContext } from "Dashboards/Common/Contracts/TeamContext";
import { IDashboardRestClient } from "Dashboards/Common/RestClient/Dashboard";
import { Constants, DashboardType, FormFields, Project, Team } from "Dashboards/DashboardPanel/Common";
import { DashboardPanel } from "Dashboards/DashboardPanel/DashboardPanel";
import * as Resources from "Dashboards/DashboardPanel/Resources";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";

interface CreateDashboardPanelProps {
    allTeams: Team[];
    onDismiss: () => void;
    onDashboardCreated: (newDashboardItem: Pick<TeamContext & Dashboard, "id" | "teamId" | "projectId">) => void;
    project: Project;
    userTeams: Team[];
}

export class CreateDashboardPanel extends VssComponent<CreateDashboardPanelProps, {}> {
    public render(): JSX.Element {
        return (
            <DashboardPanel
                allTeams={this.props.allTeams}
                onDismiss={this.props.onDismiss}
                onSubmit={this.handleSubmit}
                submitButtonLabel={Resources.CreateDashboardSubmitButtonLabel}
                title={Resources.CreateDashboardPanelTitle}
                showDashboardTypeSelector
                userTeams={this.props.userTeams}
                dashboardProject={this.props.project}
            />
        );
    }

    private handleSubmit = (fields: FormFields, selectedDashboardType: DashboardType): Promise<void> => {
        return new Promise((resolve, reject) => {
            const dashboard = {
                name: fields.name,
                description: fields.description,
                refreshInterval: fields.autoRefresh ? Constants.autoRefreshIntervalInMins : 0
            } as Dashboard;
            const teamContext = {
                teamId: selectedDashboardType === DashboardType.Team ? fields.teamId! : null,
                projectId: this.props.project.id,
                project: this.props.project.name,
                team: ""
            } as TeamContext;

            const dashboardRestClient = this.context.pageContext.getRestClient<IDashboardRestClient>("IDashboardRestClient");
            dashboardRestClient
                .createDashboard(dashboard, teamContext)
                .then((newDashboard: Dashboard) => {
                    this.props.onDashboardCreated({
                        ...teamContext,
                        ...newDashboard
                    });
                    resolve();
                })
                .catch((error: Error) => {
                    reject(error);
                });
        });
    };
}
